import { GatewayMerchantAccountConstants as Constants } from '../types'
import { gatewayMerchantAccountApi as api } from '../../api'

export const gatewayMerchantAccountAction = {
    get,
}

function get() {
    return dispatch => {
        dispatch({ type: Constants.LOADING })
        return new Promise((resolve, reject) => {
            api._get()
                .then(
                    payload => {
                        dispatch({ type: Constants.GET, payload })
                        resolve(payload)
                    },
                    error => {
                        dispatch({ type: Constants.FAIL, error })
                        reject(error)
                    }
                )
        })
    }
}
